import React from "react";
import { addStaticRootToUrl } from "@src/utils/static";
import styles from "./AuthPageLayout.module.scss";

interface AuthPageLayoutProps {
  children: React.ReactNode;
}

export default function AuthPageLayout({
  children,
}: AuthPageLayoutProps): React.JSX.Element {
  return (
    <div className={styles.page}>
      <div className={styles.logoBar}>
        <a href="/" className={styles.logoLink}>
          <img
            className={styles.logo}
            src={addStaticRootToUrl("images/logo_colored.png")}
            alt="OrderEasy Logo"
          />
        </a>
      </div>

      <div className={styles.content}>{children}</div>

      <div className={styles.footer}>
        <img
          className={styles.illustration}
          src={addStaticRootToUrl("images/vet_illustration.svg")}
          alt=""
          aria-hidden="true"
        />
        <hr className={styles.footerDivider} />
      </div>
    </div>
  );
}
